import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';
import styles from './Benefits.module.css';
import { ChevronDownButton, ChevronRightButton } from '_components';

class PatientHomeAdmissionBenefits extends React.Component {


    formatAsCurrency(value) {
        if (value != null && !isNaN(value)) {
            return '$' + parseFloat(value).toFixed(2);
        } else {
            return value;
        }
    }

    formatAsPercent(value) {
        if (value != null && !isNaN(value)) {
            let val = 100.0 * parseFloat(value);
            let fixedString = val.toFixed(2);
            return parseFloat(fixedString) + '%';
        } else {
            return value;
        }
    }

    getChevron() {
        if (this.props.visible) {
            return (<ChevronDownButton size='extra-small' className={styles.header_button} onClick={() => this.props.toggleBenefitsVisibility({ epno: this.props.epno })} />)
        } else {
            return (<ChevronRightButton size='extra-small' className={styles.header_button} onClick={() => this.props.toggleBenefitsVisibility({ epno: this.props.epno })} />)
        }
    }


    render() {
        if (this.props.benefit && this.props.benefit.py1Name) {
            return (
                <div>
                    <div className={styles.benefits_header}>
                        {this.getChevron()}

                        <span className={styles.header_text}>Benefits</span>

                    </div>
                    {this.props.visible &&
                        <>
                            <div className={styles.row_wrapper}>
                                <span className={styles.payer_col}><b>Payer</b></span>
                                <span className={styles.copay_col}><b>Copay $</b></span>
                                <span className={styles.copaypercent_col}><b>Co-Ins %</b></span>
                                <span className={styles.deduct_col}><b>Deduct.</b></span>
                                <span className={styles.deductused_col}><b>Deduct. Used</b></span>
                            </div>

                            {this.props.benefit.py1Name &&
                                <div className={styles.row_wrapper}>
                                    <span className={styles.payer_col} title={'1 - ' + this.props.benefit.py1Name}>{'1 - ' + this.props.benefit.py1Name}</span>
                                    <span className={styles.copay_col}>{this.formatAsCurrency(this.props.benefit.pb1Copay)}</span>
                                    <span className={styles.copaypercent_col}>{this.formatAsPercent(this.props.benefit.pb1CopayPercent)}</span>
                                    <span className={styles.deduct_col}>{this.formatAsCurrency(this.props.benefit.pb1Deductible)}</span>
                                    <span className={styles.deductused_col}>{this.formatAsCurrency(this.props.benefit.pb1DeductUsed)}</span>
                                </div>
                            }

                            {this.props.benefit.py2Name &&
                                <div className={styles.row_wrapper}>
                                    <span className={styles.payer_col} title={'2 - ' + this.props.benefit.py2Name}>{'2 - ' + this.props.benefit.py2Name}</span>
                                    <span className={styles.copay_col}>{this.formatAsCurrency(this.props.benefit.pb2Copay)}</span>
                                    <span className={styles.copaypercent_col}>{this.formatAsPercent(this.props.benefit.pb2CopayPercent)}</span>
                                    <span className={styles.deduct_col}>{this.formatAsCurrency(this.props.benefit.pb2Deductible)}</span>
                                    <span className={styles.deductused_col}>{this.formatAsCurrency(this.props.benefit.pb2DeductUsed)}</span>
                                </div>
                            }

                            {this.props.benefit.py3Name &&
                                <div className={styles.row_wrapper}>
                                    <span className={styles.payer_col} title={'3 - ' + this.props.benefit.py3Name}>{'3 - ' + this.props.benefit.py3Name}</span>
                                    <span className={styles.copay_col}>{this.formatAsCurrency(this.props.benefit.pb3Copay)}</span>
                                    <span className={styles.copaypercent_col}>{this.formatAsPercent(this.props.benefit.pb3CopayPercent)}</span>
                                    <span className={styles.deduct_col}>{this.formatAsCurrency(this.props.benefit.pb3Deductible)}</span>
                                    <span className={styles.deductused_col}>{this.formatAsCurrency(this.props.benefit.pb3DeductUsed)}</span>
                                </div>
                            }

                            {this.props.benefit.py4Name &&
                                <div className={styles.row_wrapper}>
                                    <span className={styles.payer_col} title={'4 - ' + this.props.benefit.py4Name}>{'4 - ' + this.props.benefit.py4Name}</span>
                                    <span className={styles.copay_col}>{this.formatAsCurrency(this.props.benefit.pb4Copay)}</span>
                                    <span className={styles.copaypercent_col}>{this.formatAsPercent(this.props.benefit.pb4CopayPercent)}</span>
                                    <span className={styles.deduct_col}>{this.formatAsCurrency(this.props.benefit.pb4Deductible)}</span>
                                    <span className={styles.deductused_col}>{this.formatAsCurrency(this.props.benefit.pb4DeductUsed)}</span>
                                </div>
                            }
                        </>
                    }
                </div>
            );
        } else {
            return (
                <div />
            );
        }
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleBenefitsVisibility: bindActionCreators(patientActions.toggleBenefitVisibility, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let benefit = state.entities.benefits[ownprops.epno];
    let visible = state.ui.benefits[ownprops.epno].visible;
    return {
        benefit,
        visible
    };
}

const connectedPatientHomeAdmissionBenefits = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionBenefits);
export { connectedPatientHomeAdmissionBenefits as PatientHomeAdmissionBenefits };

